// 2.1
// PROBLEMS
// - ie supports querySelectorAll from IE8
// - querySelectorAll can be used on xml
// ?? from which IE version
// - querySelectorAll does not suport everything
// -- namespaces https://github.com/jsdom/jsdom/issues/2028
// - IE8 is from  2009
// - xpath can be converted for trivial cases to selectors
// - selector must not start with whitespace
// - xpath returns different kinds of elements than querySelectorAll
// - querySelectorAll sometimes does not exists IE9 ... in xml with namespaces
// FIXME: childNodes do not return the same thing, because polyfill adds elements which have node.nodeType === 1 ... (https://developer.mozilla.org/en-US/docs/Web/API/ParentNode/children)
export const xml_utilities = {

    wrap_in_cdata: function( str )
    {
        return '<![CDATA[' + str + ']]>';
    },

    /**
     *
     * @param xml
     * @param xpath
     * @returns structure
     */
    get_structure_by_xpath: function ( xml, xpath )
    {
        var nodeArray = xml_utilities.get_elements_by_xpath( xml, xpath, xml_utilities.get_struct_from_node );
        var node = nodeArray[0];
        return node;
    },

    /**
     *
     * @param xml
     * @param xpath
     * @returns {Array} of structures
     */
    get_array_of_structures_by_xpath: function ( xml, xpath )
    {
        var array = [];
        xml_utilities.get_elements_by_xpath( xml, xpath, function (unprocessedXmlNode) {
            var structure = xml_utilities.get_struct_from_node(unprocessedXmlNode);
            array.push(structure);
        });
        return array;
    },

    get_value_by_xpath: function ( xml, xpath )
    {
        // TODO:
    },


    /**

     returns array of elements

     @param xml ... xml document
     @param xpath ... xpath string
     @param process_node_before_storing ... node => returned value will be stored in array
     */
    get_elements_by_xpath: function ( xml, xpath, process_node_before_storing )
    {
        if(1)
        {
            var css_selector_as_string = xpath.replace("//"," ").replace(/^\W+/,'').replace(/W+$/,'');
            var nodes;

            // IE 11
            if( xml.querySelectorAll )
            {
                nodes = xml.querySelectorAll( css_selector_as_string );
            }
            else
            {
                // IE 9
                nodes = xml.getElementsByTagName( css_selector_as_string ); // selector MUST be for one tag name!
            }

            var i;
            var node;
            var result = [];
            var pushed_value;
            for( i = 0; i < nodes.length; i++ )
            {
                node = nodes[i];
                if(process_node_before_storing)
                {
                    pushed_value = process_node_before_storing( node );
                }
                else
                {
                    if( node.hasChildNodes() )
                    {
                        pushed_value = node.childNodes[0].nodeValue;
                    }
                    else
                    {
                        // for example: <comment></comment>
                        pushed_value = node.nodeValue;
                    }
                }
                result.push( pushed_value );
            }
            return result;
        }
        else
        {
            // TODO:
            // , for example
            // - <justThisTag></justThisTag>
            // - <structure><field1>value1</field1><fields2>value2</field2></structure>
            // - <array>...</array><array></array>
            var nodes = xml.evaluate(xpath, xml, null, XPathResult.ANY_TYPE, null);
            var node_wrap = null;
            var result = [];
            while(( node_wrap = nodes.iterateNext()))
            {
                if (process_node_before_storing)
                {
                    result.push(process_node_before_storing(node_wrap));
                } else
                {
                    if( ! node_wrap.hasChildNodes() )
                    {
                        // for example: <comment></comment>
                        result.push(node_wrap.nodeValue);
                    }
                    else
                    {
                        result.push(node_wrap.childNodes[0].nodeValue);
                    }
                }
            }
            return result;
        }
    },

    // callback for process_node_before_storing() in get_elements_by_xpath()
    get_struct_from_node: function ( node )
    {
        // [4]
        var struct = {};
        for( var i = 0; i < node.childElementCount; i++ )
        {
            var currentNode = node.childNodes[i];
            if( currentNode.childElementCount > 0 )
            {
                var key = currentNode.tagName;
                var value = xml_utilities.get_struct_from_node( currentNode );
                struct[key] = value;
            }
            else
            {
                var key = currentNode.tagName;
                var value = currentNode.textContent;
                struct[key] = value;
            }
        }
        return struct;
    },

    get_first_tag_value: function ( xml, xpath, not_found_value )
    {
        var faultcode_array = xml_utilities.get_elements_by_xpath( xml, xpath );
        var faultcode = not_found_value;
        if( faultcode_array.length > 0 )
        {
            faultcode = faultcode_array[0];
        }
        return faultcode;
    },

    get_struct_from_node_handle_arrays: function ( node )
    {
        // [4]
        var struct = {};
        var pontentialArrayInfo = [];

        for( var i = 0; i < node.childElementCount; i++ )
        {
            var currentNode = node.childNodes[i];
            var key = currentNode.tagName;
            var keyIsPotentialArray = key[0].match(/[A-Z]/);
            var value = null;
            if( currentNode.childElementCount > 0 )
            {
                value = xml_utilities.get_struct_from_node_handle_arrays( currentNode );
            }
            else
            {
                value = currentNode.textContent;
            }

            if( keyIsPotentialArray )
            {
                pontentialArrayInfo[key] = pontentialArrayInfo[key] || {keyIndex:0,lastValue:null}; // get or create
                var keyIndex = pontentialArrayInfo[key].keyIndex;
                struct[key] = struct[key] || []; // init
                struct[key].push( value );
                pontentialArrayInfo[key].lastValue = value;
                pontentialArrayInfo[key].keyIndex++;
            }
            else
            {
                struct[key] = value;
            }
        }


        // create
        if( 0 )
        {
            for (var key in pontentialArrayInfo)
            {
                // they are always structures
                for (var subKey in pontentialArrayInfo[key].lastValue)
                {
                    struct[key][subKey] = pontentialArrayInfo[key].lastValue[subKey];
                }
            }
        }

        return struct;
    },

    xml_from_string_dontThrowExceptions: function( string )
    {
        try {
            var xml = new DOMParser().parseFromString(string, 'application/xml');
            return xml;
        } catch(_) {
            debugger;
            return null;
        }
    },

    /**
     *
     * @param xml_node
     * @param path_separator_as_string
     * @param path_as_string ... initial/working path
     * @param serializable_structure ... initial/working structure
     * @returns {*|{}}
     */
    serializable_structure_from_xml: function( xml_node, path_separator_as_string, path_as_string, serializable_structure )
    {
        path_as_string = path_as_string || '';
        serializable_structure = serializable_structure || {};
        path_separator_as_string = path_separator_as_string || '/';

        for( var i = 0; i < xml_node.childElementCount; i++ )
        {
            var current_node = xml_node.childNodes[i];
            var current_tag_name = current_node.tagName;
            var current_element_path;

            if( current_node.childElementCount > 0 )
            {
                current_element_path = path_as_string + path_separator_as_string + i + path_separator_as_string + current_tag_name;
                xml_utilities.serializable_structure_from_xml( current_node, path_separator_as_string, current_element_path, serializable_structure );
            }
            else
            {
                current_element_path = path_as_string + path_separator_as_string + current_tag_name;
                var value = current_node.textContent;
                serializable_structure[current_element_path] = value;
            }

        }

        return serializable_structure;
    },

    xml_from_serialiable_structure: function( serializable_structure )
    {
        // var path_as_string = path_as_string || '';
        // serializable_structure = serializable_structure || {};
        // path_separator_as_string = path_separator_as_string || '/';
        //
        // var xml = '';
        //
        // var nested_serializable_structure = {};
        //
        // for( var i = 0; i < serializable_structure; i++ )
        // {
        //     if( serializable_structure.hasOwnProperty( i ))
        //     {
        //         var path = serializable_structure[i];
        //         if( path )
        //         {
        //             path = path.replace(/^\//,''); // remove left xml
        //             var ids = path.split("/");
        //             if( ids.length > 0 )
        //             {
        //
        //                 nested_serializable_structure
        //
        //                 ( n, ids )
        //
        //                 xml += 0;
        //             }
        //         }
        //     }
        //     // current_element_path = path_as_string + path_separator_as_string + i + path_separator_as_string + current_tag_name;
        // }
        // return xml;
    },

    test: function()
    {
        ;
    }
};



// WEBPACK FOOTER //
// ./src/Atollon/utilities/xml_utilities.js